import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import {BrowserRouter} from "react-router-dom";

export const notifWorker = navigator.serviceWorker ? navigator.serviceWorker.register("/sw.js")
    .then(registration => registration.update().then(() => registration))
    .catch(console.error) : undefined;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
)
